var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('v-orders',{staticClass:"receive-orders"}),(!_vm.isShowHistory)?_c('v-map',{ref:"map",attrs:{"isShowMenu":""}}):_c('v-history',{staticClass:"order-history",attrs:{"modalFilters":true,"redirectAfterEdit":false}}),_c('v-navigation',{attrs:{"right":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }